import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal    from 'contents_modal';
// -------------------------------------------------------

class Keyword extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      type : 'or',
    };
  }
  // -------------------------------------------------------
  
  /*
   * AND / OR変更
   */
  changeType(type) {
    this.setState({ type: type });
    
    setTimeout( function(){
      this.changeSetting.bind(this)();
    }.bind(this), 150);
  }
  // -------------------------------------------------------
  
  changeSetting() {
    this.props.set_ev.bind(this)('keyword', this.keyword.value.split(/ |　/ig));
    
    if( this.keyword.value != '' ){
      this.props.set_ev.bind(this)('keyword_type', this.state.type);
    } else {
      this.props.set_ev.bind(this)('keyword_type', '');
    }
  }
  // -------------------------------------------------------
  
  render() {
    let type_list = [{ id: 'or', name: 'OR' }, { id: 'space'}, { id: 'and', name: 'AND' }];
    
    return (
      <div className="column">
        <h6>キーワード</h6>
        <input className="text" ref={(input) => { this.keyword = input }} onBlur={this.changeSetting.bind(this)} placeholder="キーワードを入力" />
        
        <div className="column-type">
          { type_list.map((d, key) => {
            if( d.id == 'space' ) return <p key={key} className="slash">/</p>;
            
            let flg = (d.id == this.state.type) ? 'on' : 'off';
            return <p key={key} className={flg} onClick={this.changeType.bind(this, d.id)}>{d.name}</p>
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Keyword;